import Vue from 'vue';
import { initials, firstWord } from './text';

Vue.filter('initials', initials);
Vue.filter('firstWord', firstWord);
